import { render, staticRenderFns } from "./GeneralResume.vue?vue&type=template&id=3ac8bf48&scoped=true&"
import script from "./GeneralResume.vue?vue&type=script&lang=js&"
export * from "./GeneralResume.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ac8bf48",
  null
  
)

export default component.exports